import Vue from 'vue';
import linkDynamic from '@editor/droplets/_bubble-options/components/link-dynamic';

export default Vue.component('edit-media-item', {
  template: require('./template.html'),
  name: 'edit-media-item',
  props: ['droplet', 'show-edit-bubble', 'profile', 'dynamic-item'],
  components: {
    linkDynamic,
  },
  data() {
    return {
      display: {
        groupHeader: false,
      },
    };
  },
  watch: {
    showEditBubble(open) {
      if (open) {
        this.setInitialValies();
      }
    },
  },
  methods: {
    setInitialValies() {
      this.display.groupHeader = this.droplet.groupHeader;
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/media-item/components/_edit-options/index.js